import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import WebFont from 'webfontloader';
import MainContainer from './containers/MainContainer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import RegisterContainer from './containers/RegisterContainer';
import SalesContainer from './containers/SalesContainer';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import ConfigContainer from './containers/ConfigContainer';
import ReportsContainer from './containers/ReportsConfainer';
import NotFoundContainer from './containers/NotFoundContainer';
import MonthlyPaymentsContainer from './containers/MonthlyPaymentsContainer';
import PaymentsDetailContainer from './containers/PaymentDetail';
import ExpenseContainer from './containers/ExpenseContainer';
import OrderContainer from './containers/OrderContainer';


WebFont.load({
  google: {
    families: ['Work Sans: 400,500,700', 'sans-serif']
  }
})

const Index = () => {
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <MainContainer>
            <Routes>
              <Route path="/register" element={<RegisterContainer />} />
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              } />
              <Route path="/sales" element={
                <PrivateRoute>
                  <SalesContainer />
                </PrivateRoute>
              } />
              <Route path="/expenses" element={
                <PrivateRoute>
                  <ExpenseContainer />
                </PrivateRoute>
              } />
              <Route path="/reports" element={
                <PrivateRoute>
                  <ReportsContainer />
                </PrivateRoute>
              } />
              <Route path="/config" element={
                <PrivateRoute>
                  <ConfigContainer />
                </PrivateRoute>
              } />
              <Route path="/monthlyPayments" element={
                <PrivateRoute>
                  <MonthlyPaymentsContainer />
                </PrivateRoute>
              } />
              <Route path="/paymentsDetail/:id" element={
                <PrivateRoute>
                  <PaymentsDetailContainer />
                </PrivateRoute>
              } />
              <Route path="/orders" element={
                <PrivateRoute>
                  <OrderContainer />
                </PrivateRoute>
              } />
              <Route path="*" element={<NotFoundContainer />} />
            </Routes>
          </MainContainer>
        </BrowserRouter>
      </AuthProvider>
    </>
  )
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Index />);
